var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800.273,
    height: 237.118,
    viewBox: "0 0 800.273 237.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.908,
    y1: 1.032,
    x2: -0.383,
    y2: 0.36,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.077,
    y1: 0.729,
    x2: -1.307,
    y2: 0.729,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.864,
    y1: -0.023,
    x2: -0.499,
    y2: -1.789,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.186,
    y1: 2.701,
    x2: 0.423,
    y2: 1.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M770.634,237.118H29.64A29.352,29.352,0,0,1,0,207.478V29.64A29.352,29.352,0,0,1,29.64,0H770.634a29.352,29.352,0,0,1,29.64,29.64V207.478A29.352,29.352,0,0,1,770.634,237.118Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M770.634,4.742a25.048,25.048,0,0,1,24.9,24.9V207.478a25.048,25.048,0,0,1-24.9,24.9H29.64a25.048,25.048,0,0,1-24.9-24.9V29.64a25.048,25.048,0,0,1,24.9-24.9H770.634m0-4.742H29.64A29.726,29.726,0,0,0,0,29.64V207.478a29.352,29.352,0,0,0,29.64,29.64H770.634a29.352,29.352,0,0,0,29.64-29.64V29.64A29.726,29.726,0,0,0,770.634,0Z",
    transform: "translate(0 0)",
    fill: "#a6a6a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M76.968,26.462c0,4.742-1.186,8.892-4.15,11.856a17.43,17.43,0,0,1-13.041,5.335,17.43,17.43,0,0,1-13.042-5.335A17.43,17.43,0,0,1,41.4,25.277a17.43,17.43,0,0,1,5.335-13.041A17.43,17.43,0,0,1,59.777,6.9,15.784,15.784,0,0,1,66.89,8.678a12.909,12.909,0,0,1,5.335,4.15l-2.964,2.964c-2.371-2.964-5.335-4.15-9.485-4.15a11.8,11.8,0,0,0-9.485,4.15c-2.964,2.371-4.15,5.928-4.15,10.078s1.186,7.706,4.15,10.078,5.928,4.15,9.485,4.15a13,13,0,0,0,10.078-4.15,9.817,9.817,0,0,0,2.964-7.114H59.777V24.091H76.968v2.371Zm27.269-14.82H88.231V22.905h14.82v4.15H88.231V38.318h16.005v4.742H83.488V7.493h20.748ZM123.8,43.061h-4.742V11.642H108.979V7.493h24.9v4.15H123.8Zm27.269,0V7.493h4.742V43.061Zm24.9,0h-4.742V11.642H161.145V7.493h24.3v4.15H175.372V43.061Zm56.316-4.742a18.607,18.607,0,0,1-26.083,0,17.43,17.43,0,0,1-5.335-13.041A17.43,17.43,0,0,1,206.2,12.235a18.607,18.607,0,0,1,26.083,0,17.43,17.43,0,0,1,5.335,13.041A17.43,17.43,0,0,1,232.28,38.318Zm-22.526-2.964a13.989,13.989,0,0,0,9.485,4.15,11.8,11.8,0,0,0,9.485-4.15,14.3,14.3,0,0,0,4.15-10.078c0-4.15-1.186-7.706-4.15-10.078a13.989,13.989,0,0,0-9.485-4.15,11.8,11.8,0,0,0-9.485,4.15,14.3,14.3,0,0,0-4.15,10.078C205.6,29.426,206.79,32.983,209.754,35.354Zm34.382,7.706V7.493h5.335l17.191,27.861V7.493H271.4V43.061h-4.742L248.286,14.014V43.061Z",
    transform: "translate(204.017 34.003)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M201.155,44.961c-14.227,0-25.49,10.67-25.49,25.49a25.3,25.3,0,0,0,25.49,25.49c14.227,0,25.49-10.67,25.49-25.49C226.645,55.039,215.382,44.961,201.155,44.961Zm0,40.31c-7.706,0-14.227-6.521-14.227-15.413s6.521-15.413,14.227-15.413,14.227,5.928,14.227,15.413C215.382,78.751,208.861,85.271,201.155,85.271Zm-55.13-40.31c-14.227,0-25.49,10.67-25.49,25.49a25.3,25.3,0,0,0,25.49,25.49c14.227,0,25.49-10.67,25.49-25.49C171.515,55.039,160.252,44.961,146.025,44.961Zm0,40.31c-7.706,0-14.227-6.521-14.227-15.413s6.521-15.413,14.227-15.413,14.227,5.928,14.227,15.413C160.252,78.751,153.731,85.271,146.025,85.271Zm-65.8-32.6v10.67h25.49a22.415,22.415,0,0,1-5.928,13.634c-3.557,3.557-9.485,7.706-19.562,7.706-16.005,0-27.861-12.449-27.861-28.454S64.812,27.77,80.224,27.77a29.393,29.393,0,0,1,19.562,7.706l7.706-7.706c-6.521-5.928-14.82-10.67-26.676-10.67C59.477,17.1,41.1,34.884,41.1,56.224S59.477,95.349,80.817,95.349c11.856,0,20.155-3.557,27.269-11.263,7.114-7.114,9.485-17.191,9.485-24.9a22.228,22.228,0,0,0-.593-6.521H80.224Zm269.129,8.3c-2.371-5.928-8.3-16.005-21.341-16.005S304.3,55.039,304.3,70.452c0,14.227,10.67,25.49,24.9,25.49a24.317,24.317,0,0,0,20.748-11.263l-8.3-5.928c-2.964,4.15-6.521,7.114-12.449,7.114s-9.485-2.371-12.449-7.706l33.789-14.227-1.186-2.964Zm-34.382,8.3c0-9.485,7.706-14.82,13.042-14.82,4.149,0,8.3,2.371,9.485,5.335l-22.526,9.485Zm-27.861,24.3h11.263v-74.1H287.11ZM269.326,50.3a19.518,19.518,0,0,0-13.634-5.928c-12.449,0-24.3,11.263-24.3,25.49a24.546,24.546,0,0,0,24.3,24.9,17.021,17.021,0,0,0,13.042-5.928h.593v3.557c0,9.485-5.335,14.82-13.634,14.82a13.17,13.17,0,0,1-12.449-8.892l-9.485,4.15c2.964,6.521,10.078,14.82,22.526,14.82,13.042,0,23.712-7.706,23.712-26.083V46.147h-10.67V50.3ZM256.285,85.271c-7.706,0-14.227-6.521-14.227-15.413s6.521-15.413,14.227-15.413,13.634,6.521,13.634,15.413S263.991,85.271,256.285,85.271Zm144.642-65.8H374.251v74.1h11.263V65.709h15.413c12.449,0,24.3-8.892,24.3-23.119S413.375,19.471,400.927,19.471Zm.593,35.568H385.514V29.549H401.52A13.021,13.021,0,0,1,414.561,42c-.593,6.521-5.335,13.041-13.041,13.041Zm68.171-10.67c-8.3,0-16.6,3.557-19.562,11.263l10.078,4.15c2.371-4.15,5.928-5.335,10.078-5.335,5.928,0,11.263,3.557,11.856,9.485v.593a23.513,23.513,0,0,0-11.263-2.964c-10.67,0-21.341,5.928-21.341,16.6,0,10.078,8.892,16.6,18.377,16.6,7.706,0,11.263-3.557,14.227-7.114h.593v5.928H493.4V65.116c-1.186-13.041-11.263-20.748-23.712-20.748Zm-1.186,40.9c-3.557,0-8.892-1.778-8.892-6.521,0-5.928,6.521-7.706,11.856-7.706,4.742,0,7.114,1.186,10.077,2.371C480.361,80.529,474.433,85.271,468.505,85.271Zm62.243-39.124L518.3,78.158h-.593L504.666,46.147H492.81L512.372,91.2l-11.263,24.9h11.263L542.6,46.147H530.749Zm-99.59,47.424h11.263v-74.1H431.159Z",
    transform: "translate(202.539 84.268)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M12.371,7.5C10.593,9.278,10,12.242,10,15.8V146.807a11.727,11.727,0,0,0,2.964,8.3l.593.593L87.063,82.192V81.007Z",
    transform: "translate(49.28 36.96)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M47.2,66.188l-24.3-24.3V40.1L47.2,15.8l.593.593,29.047,16.6c8.3,4.742,8.3,12.449,0,17.191Z",
    transform: "translate(112.85 77.862)",
    fill: "url(#linear-gradient-2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M109.4,44.9,84.5,20,10.4,94.1c2.964,2.964,7.114,2.964,12.449.593L109.4,44.9",
    transform: "translate(51.251 98.559)",
    fill: "url(#linear-gradient-3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M109.4,58.322,22.849,9.12c-5.335-2.964-9.485-2.371-12.449.593L84.5,83.219l24.9-24.9Z",
    transform: "translate(51.251 35.34)",
    fill: "url(#linear-gradient-4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M108.8,24.1,22.849,72.709c-4.742,2.964-8.892,2.371-11.856,0L10.4,73.3l.593.593c2.964,2.371,7.114,2.964,11.856,0Z",
    transform: "translate(51.251 118.764)",
    opacity: 0.2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M12.371,92.914C10.593,91.135,10,88.171,10,84.615v.593a11.727,11.727,0,0,0,2.964,8.3v-.593h-.593ZM140.415,27.706l-29.64,16.6.593.593,29.047-16.6c4.15-2.371,5.928-5.335,5.928-8.3C146.343,22.964,143.972,25.335,140.415,27.706Z",
    transform: "translate(49.28 98.559)",
    opacity: 0.12
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M24.82,9.831l115.6,65.8c3.557,2.371,5.928,4.742,5.928,7.706,0-2.964-1.778-5.928-5.928-8.3L24.82,9.239C16.521,4.5,10,8.053,10,17.538v.593C10,9.239,16.521,5.089,24.82,9.831Z",
    transform: "translate(49.28 35.221)",
    fill: "#fff",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.3642183388678a4535854cc331621284.svg";
export { ForwardRef as ReactComponent };